module.exports = __webpack_public_path__ + "static/icon-information-88ad11a5d6144c17b2eac27e80435e9f.svg";